import { Api } from "../axios.config";

const path = "/external_content_sources";

export const createExternalContentSource = (payload) => {
  return Api.post(path, payload);
};

export const syncExternalContentSource = (id) => {
  return Api.post(`${path}/${id}/sync`);
};
